module.exports = __webpack_public_path__ + "static/media/illustration_disabled.08a3deeb.svg";